module.exports = __webpack_public_path__ + "static/media/wheel-tab.72de2d7c.png";